<template>
  <div class="monitor-container">
    <div class="container-header">
      <div class="selected-activity caption bold">{{ eventName }}</div>
      <ul class="flex base-info-list flex-between">
        <li class="item">
          <span>事件显示名：</span>
          <span>{{ eventInfo.attrName }}</span>
        </li>
        <li class="item">
          <span>覆盖端：</span>
          <span>{{ eventInfo.platform }}</span>
        </li>
        <li class="item">
          <span>状态：</span>
          <span v-if="eventInfo.validateInfo === '有效'" class="success"
            >已启用</span
          >
          <span v-else class="danger">已停用</span>
        </li>
        <li class="item">
          <span>创建人：</span>
          <span>{{ eventInfo.createBy }}</span>
        </li>
        <li class="item">
          <span>创建时间：</span>
          <span>{{ eventInfo.createTime }}</span>
        </li>
      </ul>
      <div class="flex mt20">
        <div class="mr20">
          <span>时间：</span>
          <el-date-picker
            v-model="date"
            size="small"
            type="daterange"
            :clearable="false"
            @change="changeDate"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </div>
        <div>
          <span>对比时间段：</span>
          <el-radio-group
            @change="queryDetails"
            size="small"
            v-model="groupType"
          >
            <el-radio-button label="hour">按时</el-radio-button>
            <el-radio-button label="day">按天</el-radio-button>
            <el-radio-button label="month">按月</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="chart-wrapper">
      <ve-line
        :data-empty="dataEmpty"
        :legend="legend"
        :data="chartData"
      ></ve-line>
    </div>
    <div class="table-wrapper">
      <el-table
        stripe
        height="600px"
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          prop="date"
          label="日期"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="count"
          label="次数"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import moment from "moment";
import "v-charts/lib/style.css";
export default {
  components: {
    VeLine
  },
  data() {
    return {
      chartData: {
        columns: [],
        rows: []
      },
      id: "",
      dataEmpty: false,
      createBy: "",
      eventInfo: {},
      list: [],
      legend: { show: false },
      groupType: "hour",
      eventState: "",
      eventName: "",
      date: [new Date(), new Date()],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.queryDetails();
  },
  mounted() {},
  methods: {
    changeDate(date) {
      const startDate = moment(date[0]);
      const endDate = moment(date[1]);
      const day = endDate.diff(startDate, "day") + 1;
      if (day > 3 && this.groupType === "hour") {
        this.$message({
          type: "warning",
          message: "按时查看只能选择3天"
        });
        this.date = [
          moment(endDate)
            .subtract(2, "days")
            .format("YYYY-MM-DD"),
          moment(endDate).format("YYYY-MM-DD")
        ];
      }
      this.queryDetails();
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryViewTimes", {
        startDate: moment(this.date[0]).format("YYYY-MM-DD"),
        endDate: moment(this.date[1]).format("YYYY-MM-DD"),
        groupType: this.groupType,
        id: this.id
      });
      const { eventInfo, data } = result;
      this.eventInfo = eventInfo;
      this.list = data || [];
      this.dataEmpty = !this.list.length;
      let rows = [];
      this.list.forEach(v => {
        rows.push({
          日期: v.date,
          次数: v.count
        });
      });
      this.chartData = {
        columns: ["日期", "次数"],
        rows
      };
    }
  }
};
</script>

<style scoped lang="scss">
.monitor-container {
  font-size: 14px;
  .container-header {
    background: #fff;
    padding: 19px 40px;
  }
  .base-info-list {
    font-size: 14px;
  }

  .chart-wrapper {
    margin-top: 20px;
    padding: 30px;
    background: #fff;
  }

  .table-wrapper {
    margin-top: 20px;
    padding: 30px;
    background: #fff;
  }
}
</style>
